const adminDownloadRouter = [
  {
    path: '/admin/download',
    name: 'AdminDownloadIndex',
    component: () => import('@/views/admin/download/index')
  },
  {
    path: '/admin/download/csv',
    name: 'AdminDownloadCsv',
    component: () => import('@/views/admin/download/csv')
  }
]

export default adminDownloadRouter



// WEBPACK FOOTER //
// ./src/router/modules/admin/download.js